import React from 'react'

const Title = ({title, des}) => {
  return (
    <div className="flex flex-col items-center text-center gap-4 font-titleFont mb-16">
      <h3 className="text-xs md:text-sm uppercase font-medium text-designColor tracking-[5px]">
       {title}
      </h3>
      <h1 className="text-4xl md:text-5xl text-white font-bold capitalize">{des}</h1>
      <span className="w-16 h-[3px] rounded-full bg-gradient-to-r from-designColor to-[#ff8a5c]"></span>
    </div>
  );
}

export default Title
